import React from 'react';

const Privacy = () => {
  return (
    <div dir="ltr" className="min-h-screen bg-[#120F1D] text-gray-300 p-6 max-w-2xl mx-auto font-sans text-left">
      <h1 className="text-2xl font-bold text-white mb-4">Privacy Policy</h1>
      <p className="text-sm leading-relaxed mb-4">
        Your privacy is important to us. Here is how CandleDuel handles user data:
      </p>
      <ul className="list-disc pl-5 text-sm space-y-2 text-gray-400">
        <li>We do not collect or store personal identity data like names, email addresses, or phone numbers.</li>
        <li>We only process your public Telegram ID and public Web3 wallet address for authentication and balance tracking.</li>
        <li>No cookies or third-party trackers are used for behavioral profiling.</li>
      </ul>
    </div>
  );
};

export default Privacy;